import type { PartnerConfig } from '../types';

interface HeaderProps {
  config: PartnerConfig;
}

export function Header({ config }: HeaderProps) {
  // Use white background for Kronium-style header
  const useWhiteHeader = config.branding.tier === 'themed';
  const primaryColor = config.branding.colors.primary;

  return (
    <div
      className={`border-b px-4 py-3 ${
        useWhiteHeader
          ? 'bg-white'
          : 'bg-blue-600 text-white'
      }`}
      style={{
        backgroundColor: useWhiteHeader ? config.branding.colors.background : primaryColor,
        color: useWhiteHeader ? config.branding.colors.text : '#ffffff',
        borderBottomColor: useWhiteHeader ? '#e0e0e0' : 'transparent',
      }}
    >
      <div className="flex items-center space-x-3">
        {config.branding.logo_url ? (
          <img
            src={config.branding.logo_url}
            alt={`${config.name} logo`}
            className="h-10 w-auto"
          />
        ) : (
          // Text-based logo with brand color accent
          <div
            className="text-2xl font-bold"
            style={{ color: primaryColor }}
          >
            Kronium
          </div>
        )}
        <div className="flex flex-col">
          {config.branding.logo_url && (
            <h1 className="font-semibold text-base leading-tight">{config.name}</h1>
          )}
          <p className={`text-sm ${useWhiteHeader ? 'text-gray-500' : 'opacity-80'}`}>
            {config.branding.logo_url ? 'Product Support' : 'Product Assistant'}
          </p>
        </div>
      </div>
    </div>
  );
}
